import { useState } from "react";

export const useLocalStorage = (keyName: string, defaultValue: string) => {
	const [storedValue, setStoredValue] = useState(() => {
		try {
			const value = localStorage.getItem(keyName);
			if (value) {
				return value;
			}
			localStorage.setItem(keyName, defaultValue);
			return defaultValue;
		} catch (err) {
			return defaultValue;
		}
	});
	const setValue = (newValue: string) => {
		try {
			localStorage.setItem(keyName, JSON.stringify(newValue));
		} catch (err) {
			// something went wrong
		}
		setStoredValue(newValue);
	};
	return { storedValue, setValue };
};
